<div class="success-icon">
    <div class="success-icon__tip"></div>
    <div class="success-icon__long"></div>
</div>